import React from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn-lite';

import {compose} from 'recompose';
import withMobile from 'hoc/withMobile';
import withTranslation from 'hoc/withTranslation';

import Tabs from 'components/Tabs/Tabs';
import Section from 'components/Section/Section';
import SpeechKitTTS from 'components/SpeechKitTTS/SpeechKitTTS';
import SpeechKitSR from 'components/SpeechKitSR/SpeechKitSR';

import './SpeechKitDemo.scss';

const b = block('SpeechKitDemo');

class SpeechKitDemo extends React.Component {
    static propTypes = {
        isMobile: PropTypes.bool.isRequired,
        isConstructorVersion: PropTypes.bool,
        i18nK: PropTypes.func,
    };

    state = {
        isMounted: false,
    };

    componentDidMount() {
        this.setState({isMounted: true});
    }

    render() {
        const {isMobile, isConstructorVersion, i18nK} = this.props;
        const {isMounted} = this.state;

        if (!isMounted || (isMobile && !isConstructorVersion)) {
            return null;
        }

        return (
            <Section id="demo" className={b({constructor: isConstructorVersion})}>
                {!isConstructorVersion && <h2>{i18nK('title')}</h2>}
                <div className={b('wrap')}>
                    {isConstructorVersion && <h2 className={b('title')}>{i18nK('title')}</h2>}
                    <Tabs theme="full">
                        <Tabs.Tab key={1} title={i18nK('tab-text_to_speech')}>
                            <SpeechKitTTS isConstructorVersion={isConstructorVersion} />
                        </Tabs.Tab>
                        <Tabs.Tab key={2} title={i18nK('tab-speech_recognition')}>
                            <SpeechKitSR isConstructorVersion={isConstructorVersion} />
                        </Tabs.Tab>
                    </Tabs>
                </div>
            </Section>
        );
    }
}

export default compose(withMobile, withTranslation('speechkit-demo'))(SpeechKitDemo);
